/* eslint-disable */

export function LoadingSpinner({ pesan = 'Memuat data...' }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'48px', gap:'16px' }}>
      <div style={{
        width:'40px', height:'40px',
        border:'4px solid #f0f4f8',
        borderTop:'4px solid #2d6a9f',
        borderRadius:'50%',
        animation:'spin 0.8s linear infinite'
      }} />
      <p style={{ color:'#888', fontSize:'13px', margin:0 }}>{pesan}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function ErrorBox({ pesan, onRetry }) {
  return (
    <div style={{ padding:'24px', textAlign:'center', background:'#fdedec', borderRadius:'12px', border:'1px solid #f5b7b1' }}>
      <div style={{ fontSize:'32px', marginBottom:'8px' }}>❌</div>
      <p style={{ color:'#c0392b', fontSize:'13px', marginBottom:'12px' }}>{pesan}</p>
      {onRetry && (
        <button onClick={onRetry} style={{ padding:'8px 20px', background:'#e74c3c', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'600' }}>
          Coba Lagi
        </button>
      )}
    </div>
  );
}

export function EmptyState({ icon='📭', judul='Tidak ada data', sub='Belum ada data yang tersedia' }) {
  return (
    <div style={{ padding:'48px', textAlign:'center' }}>
      <div style={{ fontSize:'48px', marginBottom:'12px' }}>{icon}</div>
      <h3 style={{ color:'#1a3a5c', fontSize:'16px', marginBottom:'6px' }}>{judul}</h3>
      <p style={{ color:'#aaa', fontSize:'13px', margin:0 }}>{sub}</p>
    </div>
  );
}